import {Flex, Image, Text} from '@chakra-ui/react'
import BadPauseIcon from '@assets/svgs/exam/bad-pause.svg'
import WrongSoundIcon from '@assets/svgs/exam/wrong-sound.svg'
import MissingSoundIcon from '@assets/svgs/exam/missing-sound.svg'
import CorrectSoundIcon from '@assets/svgs/exam/correct-sound.svg'

const StatusPhrase = () => {
  return (
    <Flex
      display={{base: 'none', md: 'flex'}}
      position={'absolute'}
      right={0}
      top={'50%'}
      transform={'translateY(-50%)'}
      p={'16px'}
      bg={'white'}
      flexDirection={'column'}
      gap={'16px'}
      borderRadius={'16px 0px 0px 16px'}
      border={'2px solid #F0F0F0'}
      borderRight={'none'}>
      <Flex gap={'8px'} alignItems={'center'}>
        <Image src={BadPauseIcon} />
        <Text fontSize={'16px'} fontWeight={500} color={'#595959'}>
          Bad pause
        </Text>
      </Flex>
      <Flex gap={'8px'} alignItems={'center'}>
        <Image src={WrongSoundIcon} />
        <Text fontSize={'16px'} fontWeight={500} color={'#595959'}>
          Sai âm
        </Text>
      </Flex>
      <Flex gap={'8px'} alignItems={'center'}>
        <Image src={MissingSoundIcon} />
        <Text fontSize={'16px'} fontWeight={500} color={'#595959'}>
          Thiếu âm
        </Text>
      </Flex>
      <Flex gap={'8px'} alignItems={'center'}>
        <Image src={CorrectSoundIcon} />
        <Text fontSize={'16px'} fontWeight={500} color={'#595959'}>
          Đúng âm
        </Text>
      </Flex>
    </Flex>
  )
}

export default StatusPhrase
